import { Navigation } from "@/components/Navigation"
import { Footer } from "@/components/Footer"
import { LeadershipSection } from "@/components/LeadershipSection"
import { PageFAQ } from "@/components/PageFAQ"
import { leadershipFAQs } from "@/data/faqData"

import { SEO } from "@/components/SEO"

const LeadershipTeam = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Leadership Team | RSA Tech Group"
        description="Meet the visionaries driving the cognitive enterprise. Our leadership team combines deep industry expertise with technical innovation."
        image="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=2600"
      />
      <Navigation />
      <div className="pt-24">
        <LeadershipSection />
      </div>
      <PageFAQ
        faqs={leadershipFAQs}
        title="Leadership FAQs"
        subtitle="Common questions about RSA Tech Group's leadership team"
        variant="muted"
      />
      <Footer />
    </div>
  )
}

export default LeadershipTeam
